import DashboardIcon from "@material-ui/icons/Dashboard";
import { IRoute } from "src/common/typings/routes";
import { ListWorkOrders } from "./pages/ListOfWorkOrders";
import { WODetails } from "./pages/WODetails";
import { WorkOrderModule } from "./WorkOrderModule";

export const WorkOrderRoute: IRoute = {
  title: "Work Orders",
  path: "/work-order",
  icon: DashboardIcon,
  component: WorkOrderModule,
  subRoutes: [
    {
      component: ListWorkOrders,
      path: "/list-work-orders",
      title: "List of Work Orders",
    },
    {
      component: WODetails,
      path: "/work-order-details",
      pathParam: "/:id/:ordNum/:crewId",
      title: "Work Order Details",
      noDrawer: true,
    },
  ],
};
